import React, {Component} from 'react';
import './Actualite.css';
import photoActualite from '../../assets/Jds.png';

class Actualite extends Component {

    goToArticle(article) {
        window.open(article);
    }

    render() {
        return (

            <div id="actualites" className="row home-block">

                <div>
                    <h2 className="title">Actualité</h2>

                    <div className="row actualite" onClick={() => this.goToArticle('https://jds2024.sciencesconf.org/')}>
                        <div className="col-md-3 col-xs-12">
                            <img id="photoActualite" src={photoActualite} alt="photoActualite" />
                        </div>

                        <div className="col-md-9 col-xs-12">
                            <p>J'interviendrai aux prochaine Journées de la statistique 2024 à Bordeaux pour présenter mon travail sur le process mining et le sport.</p>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default Actualite;



// WEBPACK FOOTER //
// ./src/Components/Actualite/Actualite.js